import type { PageProps } from 'gatsby';
import React from 'react';

import { TrackerType } from '@models/vital-sign';

import Drilldown from '@views/Records/HealthTracker/Drilldown';

export default function SleepDrilldownPage({ params }: PageProps) {
  return <Drilldown category={TrackerType.Sleep} {...params} />;
}
